import { useNavigate } from 'react-router-dom'

interface PageHeaderProps {
  title: string
  onBack?: () => void
}

export default function PageHeader({ title, onBack }: PageHeaderProps) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <header
      className="fixed top-0 z-50 h-14 w-full flex items-center px-4"
      style={{
        maxWidth: 430,
        background: 'rgba(7,6,11,0.95)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(46,107,255,0.15)',
      }}
    >
      <button
        onClick={handleBack}
        className="flex items-center mr-3"
        aria-label="返回"
        style={{ minHeight: 0 }}
      >
        <span className="material-icons" style={{ color: '#A1A1AA', fontSize: 22 }}>arrow_back_ios</span>
      </button>

      <span
        className="font-semibold text-base"
        style={{ color: '#FFFFFF' }}
      >
        {title}
      </span>
    </header>
  )
}
